.customer-organization-form__device_enrollment__device-enrollment-info-inputs-container {
  width: 360px;
}
